<template>
  <table align="center">
    <tr>
      <td >
      <el-form :model="ruleForm"
           status-icon
           :rules="rules"
           ref="ruleForm"
           label-width="160px">
    <h2>Reset Password</h2>
    <el-form-item label="Your Email"
                  prop="email">
      <el-input type="text"
                v-model="userEmail"
                auto-complete="off"
                disabled></el-input>
    </el-form-item>
    <el-form-item label="New Password"
                  prop="newPassword" style="margin-bottom: 40px;">
      <el-input type="password"
                v-model="ruleForm.newPassword"
                auto-complete="off"></el-input>
    </el-form-item>
    <el-form-item label="Confirm New Password"
                  prop="checkPassword">
      <el-input type="password"
                v-model="ruleForm.checkPassword"
                auto-complete="off"></el-input>
    </el-form-item>
    <el-form-item>
      <el-button type="primary"
                 @click="submitForm('ruleForm')">Submit</el-button>
      <el-button @click="resetForm('ruleForm')">Reset</el-button>
    </el-form-item>
  </el-form>
</td>
</tr>
  </table>


</template>

<script>
import Auth from '../utils/auth';

export default {
  created() {
    this.checkIfActive();
  },
  data() {
    var validateCheckNewPassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please input the password'));
      } else if (value !== this.ruleForm.newPassword) {
        callback(new Error("Two inputs don't match!"));
      } else {
        callback();
      }
    };
    return {
      userEmail: '',
      ruleForm: {
        newPassword: '',
        checkPassword: '',
      },
      rules: {
        newPassword: [
          {
            trigger: 'blur',
            required: true,
            message: 'Required',
          },
          {
            trigger: 'blur',
            pattern: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
            message: `At least 8 from the mentioned characters.
            Should contain at least one digit, one lower case, one upper case.`,
          },
        ],
        checkPassword: [
          { validator: validateCheckNewPassword, trigger: 'blur' },
        ],
      },
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.axios({
            method: 'post',
            url: '/user/active',
            data: {
              verifyID: this.$route.query.verifyID,
              password: this.ruleForm.newPassword,
            },
          })
            .then(res => {
              if (res.status === 201) {
                this.$router.push('/login');
                Auth.logout();
                this.$alert(
                  `<p>Our site link:</p>
                    <p>
                      <b style="color:rgb(6, 112, 187);font-size:16px;">
                      <a href="https://author.businessexpertpress.com">
                      https://author.businessexpertpress.com</a></b>
                    </p>
                    <p>Your account info:</p>
                    <p>Account:
                      <b style="color:rgb(6, 112, 187);font-size:16px;">${
                        this.userEmail
                      }</b>
                    </p>
                    <p>Password:
                      <b style="color:rgb(6, 112, 187);font-size:16px;">${
                        this.ruleForm.newPassword
                      }</b>
                    </p>
                  `,
                  'Activate Success',
                  {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: 'Got it',
                  }
                ).catch(() => {});
              }
            })
            .catch(err => {
              this.$message({
                message:
                  'Account active fail, please contact the system admin.',
                type: 'error',
              });
            });
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    checkIfActive() {
      this.axios({
        method: 'get',
        url: `/user/active?verifyID=${this.$route.query.verifyID}`,
        data: {
          newPassword: this.ruleForm.newPassword,
        },
      })
        .then(res => {
          this.userEmail = res.data.userEmail;
        })
        .catch(err => {
          this.$router.push('/login');
          this.$message({
            message:
              'The activation link is expired. \nNote: the activation link can only be used once. It will expire after the first time you click it.',
            type: 'warning',
          });
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ResetPassword.vue